import { Component, OnInit, ElementRef, ChangeDetectorRef, ChangeDetectionStrategy } from '@angular/core';
import { InputComponent } from '../input/input.component';
import { SLLayer } from 'src/app/model/sl-layer';
import { AttributeInfo } from 'src/app/types/@types/sl-v-types';
import { LinkQualifierService } from 'src/app/model/api-services/qualifiers/link-qualifier.service';
import { CastingLinkValue } from 'src/app/components/att-casting-view/formats/casting-link/casting-link.component';

@Component({
	selector: 'app-link-input',
	templateUrl: './link-input.component.html',
	styleUrls: ['./link-input.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class LinkInputComponent extends InputComponent implements OnInit {

	public hasBaseURL = false;
	public linkBase = '';
	public link = '';
	public linkText = '';
	public testLink = '';
	public hasURL = false;
	public set currentValue(val: any) {
		switch (val) {
			case null:
			case undefined:
				val = '';
		}
		super.currentValue = val;
		if (this.hasCasting) {
			if (!!this.casting.link) {
				const linkInfo: CastingLinkValue = this.casting.link;
				this.link = LinkQualifierService.FromString(val as string, linkInfo);
				super.currentValue = LinkQualifierService.ToString(val as string, linkInfo)
				this.testLink = this.currentValue;
				if (linkInfo.base !== '') {
					this.linkBase = linkInfo.base;
					this.hasBaseURL = true;
				}
				if (this.testLink.substr(0, 4).toLowerCase() === 'http') {
					this.hasURL = true;

				} else {
					this.hasURL = false;

				}
				return;
			}
		};
		let strVal: string = val as string;
		if (this.hasBaseURL === true) {
			if (strVal.length > 0) {
				if (strVal.substr(0, 1) === '/') {

					strVal = strVal.substr(1);
				}
			}
			this.testLink = this.linkBase + strVal;
		}
		this.testLink = strVal;
		this.link = strVal;
		if (this.testLink.substr(0, 4).toLowerCase() === 'http') {
			this.hasURL = true;
		} else {
			this.hasURL = false;
		}
	}
	public get currentValue(): any {
		return super.currentValue;
	}
	constructor(private domNode: ElementRef,protected cdr:ChangeDetectorRef) {
		super(cdr);
		super._domNode = this.domNode;
	}

	SetAttribute(layer: SLLayer, attribute: AttributeInfo) {
		super.SetAttribute(layer, attribute);

		this.currentValue = this.currentValue;
	}

	Reset() {
		super.Reset();

	}

	ngOnInit(): void {
		super.ngOnInit();
	}
	Update(val: string) {
		this.currentValue = val;

	}

}
